import { render, staticRenderFns } from "./customer-address.vue?vue&type=template&id=3b92de55&"
import script from "./customer-address.vue?vue&type=script&lang=js&"
export * from "./customer-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports